import { API_CALENDAR_PREFIX, SuiteApiClient } from "@weco/suite-client";

export const calendarApi = new SuiteApiClient(API_CALENDAR_PREFIX);
